<section class="mt-28 ml-28 mr-8 h-full">
  <app-communication-search-bar
    [searchValue]="searchValue"
    [placeholder]="literalService.get('communications.search', true)"
    [searching]="searching"
    [communicationType]="communicationType"
    [communicationUserType]="communicationUserType"
    (filter)="filter($event)"
    (searchEventEmitter)="search($event)"
    (sort)="sortSuggestions()"
    (addCommunicationEventEmitter)="addCommunication()"
    (changeCommunicationTypeEmitter)="changeCommunication($event)"
    (changeCommunicationUserTypeEmitter)="toggleUserType()"
  ></app-communication-search-bar>
</section>
<section class="mt-5 h-full">
  @if (communicationType === CommunicationTypes.SUGGESTIONS) {
    <app-suggestions-table
      [suggestions]="suggestions"
      [userType]="communicationUserType"
      (selectSuggestion)="showSuggestionData($event)"
      (changePriority)="updatePriority($event)"
      (changeStatus)="updateStatus($event)"
    ></app-suggestions-table>
  }
  @else {
    <app-messages-table
      [messages]="messages"
      (selectMessage)="showMessageData($event)"
      (selectMessageDetail)="showMessageDetail($event)"
    ></app-messages-table>
  }
    
   @if (communicationType === CommunicationTypes.SUGGESTIONS && ((suggestions.value && suggestions.value.length > 0) || suggestions.isFetchingSuggestion)) {
    <app-pagination [pagination]="suggestions.pagination" [loading]="suggestions.isFetchingSuggestion && !suggestions.pagination.totalPages" [baseUrl]="communicationType + '/' + communicationUserType" (changePage)="changePage($event)" />
  }
  @if (communicationType === CommunicationTypes.MESSAGES && ((messages.value && messages.value.length > 0) || messages.isFetchingMessages)) {
    <app-pagination [pagination]="messages.pagination" [loading]="messages.isFetchingMessages && !messages.pagination.totalPages" [baseUrl]="communicationType + '/' + communicationUserType" (changePage)="changePage($event)" />
  }

  <app-suggestion-details [suggestion]="suggestionSelected || newSuggestion" [userType]="communicationUserType" [newSuggestion]="newSuggestion" [editSuggestion]="editSuggestion" [shouldOpenConversation]="shouldOpenConversation" (closeDetails)="closeDetails()" (suggestionEdited)="suggestionEdited($event)" ></app-suggestion-details>
  <app-message-details [message]="messageSelected || newMessage" [newMessage]="newMessage" [communicationUserType]="communicationUserType" (closeDetails)="closeDetails()" (refreshMessages)="refreshData()" ></app-message-details>
  <app-modal-message-detail [id]="'messageDetail'" [modal]="messageDetailModal" [message]="messageDetailSelected" [list]="messageDetailsList" (userClickEmitter)="openUserDetail($event)" (updateList)="updateMessageDetail($event)" ></app-modal-message-detail>
</section>